import { render, staticRenderFns } from "./LinkedWorkItems.vue?vue&type=template&id=2857e32c&scoped=true"
import script from "./LinkedWorkItems.vue?vue&type=script&lang=js"
export * from "./LinkedWorkItems.vue?vue&type=script&lang=js"
import style0 from "./LinkedWorkItems.vue?vue&type=style&index=0&id=2857e32c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2857e32c",
  null
  
)

export default component.exports